<div
  apFoxitViewer
  rendererName="sign"
  [afterCreate]="afterCreateRenderer"
  class="ap-foxit-pdf-web-parent"
  style="width:100%;height:800px;"
></div>
